import { Box, Menu, Typography } from "@mui/material";
import { useState } from "react";
import { TbProgress } from "react-icons/tb";

function Dropdown({
    children,
    content,
    disabled,
    className,
    title,
    footerHint,
}: {
    children: React.ReactNode | React.ReactNode[];
    content?: ({ handleClose }: { handleClose: () => void }) => React.ReactNode | React.ReactNode[];
    disabled?: boolean;
    className?: string;
    title?: string;
    footerHint?: string;
}) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        if (disabled) return;
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    if (!content) return <div className={`flex justify-center w-full h-full ${className}`}>{children}</div>;

    return (
        <>
            <div
                className={`flex hover:scale-105 duration-200 active:scale-95 cursor-pointer ${className}`}
                onClick={handleClick}
            >
                {children}
            </div>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
            >
                {title && (
                    <div className="px-2 py-1 border-b flex items-center gap-1 text-sm">
                        <TbProgress /> {title}
                    </div>
                )}
                {content({ handleClose })}
                {footerHint && (
                    <Box sx={{ p: 1, borderTop: "1px solid #e0e0e0" }}>
                        <Typography variant="caption" color="text.secondary">
                            {footerHint}
                        </Typography>
                    </Box>
                )}
            </Menu>
        </>
    );
}

export default Dropdown;
